import { useEffect } from "react";

import { useTranslation } from "react-i18next";

import DeletedLeadsTable from "../../components/leads/DeletedLeadsTable";
import { usePageNameContext } from "../../contexts/PageTitleContext";

export default function DeletedLeads() {
  const { t } = useTranslation("leads");
  const { setInfo } = usePageNameContext();

  useEffect(() => {
    setInfo({
      name: t("Deleted Leads"),
      desc: t("View soft-deleted leads and who deleted them"),
    });
  }, [setInfo, t]);

  return <DeletedLeadsTable />;
}
